import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import * as transitions from 'view/styles/transitions';
import JsdIcon from 'assets/images/jsd-icon.react.svg';
import { HtmlAnchor } from '@atlassian/help-center-common-component/analytics/html-anchor';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

const footerPadding = grid.multiple(6).unitless;
export const footerJsdIconHeight = grid.multiple(2.5).unitless;
export const FOOTER_HEIGHT = footerPadding * 2 + footerJsdIconHeight;

export const FooterContainer = styled.footer`
    padding: ${footerPadding}px 0;
    text-align: center;
    white-space: nowrap;
`;

export const FooterJsdIcon = styled(JsdIcon)`
    height: ${footerJsdIconHeight}px;
    vertical-align: middle;
    opacity: 0.5;
    transition: opacity ${transitions.timingFunctions.easeInOut} ${transitions.speedMs.fast}ms;
`;

export const FooterLink = styled(HtmlAnchor)`
    ${fonts.small};
    color: ${token('color.text.subtlest', colors.N300)};
    cursor: pointer;

    :hover,
    :active {
        color: ${token('color.text.subtlest', colors.N300)};
        text-decoration: none;

        ${FooterJsdIcon} {
            opacity: 1;

            stop:first-child {
                stop-color: ${token('color.background.brand.bold.hovered', colors.B400)};
            }

            stop:last-child {
                stop-color: ${token('color.background.brand.bold', colors.B200)};
            }

            > g > g > path:last-child {
                fill: ${token('color.background.brand.bold', colors.B200)};
            }
        }
    }
`;
